

import Vue from 'vue'
import Component from "vue-class-component";
import {IOnOffHandlers} from "bonomo/dist";
import {namespace} from "vuex-class";
import {IErrors} from "@/model/IErrors";
import {ITranslationEntry, ITranslationMeta} from "@/store/modules/settings/translationModule";

const translationModule = namespace("translationModule");

@Component
export default class Translations extends Vue {

  @translationModule.Getter('translations')
  private translations!: ITranslationEntry[];
  @translationModule.Getter('meta')
  private meta!: ITranslationMeta;
  @translationModule.Getter('errors')
  private errors!: IErrors;

  protected loading: boolean = true;
  protected saving: boolean = false;
  protected search: string = '';
  protected filterMode: string = 'all';
  protected editingKey: string = '';
  protected editForm: { [locale: string]: string } = {};
  protected showCreateDialog: boolean = false;
  protected createForm: { group: string; item: string; translations: { [locale: string]: string } } = {
    group: '',
    item: '',
    translations: {},
  };

  private subscribes: IOnOffHandlers = {};
  private searchTimeout: number = 0;

  protected get filterOptions() {
    return [
      { text: this.$t('common.all'), value: 'all' },
      { text: this.$t('settings.translations.incomplete'), value: 'incomplete' },
    ];
  }

  protected get languages(): { code: string; name: string }[] {
    return this.meta.languages || [];
  }

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.loadData,
      'backend.call.OK.translationsLoaded': this.onLoadedOK,
      'backend.call.KO.translationsLoaded': this.onLoadedKO,
      'backend.call.OK.metaLoaded': this.onMetaLoaded,
      'backend.call.OK.translationSaved': this.onSaveOK,
      'backend.call.KO.translationSaved': this.onSaveKO,
    });
    this.$store.dispatch('translationModule/fetchMeta');
    this.loadData();
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private loadData() {
    this.loading = true;
    const params: any = {};
    if (this.search) params.search = this.search;
    if (this.filterMode === 'incomplete') params.filter = 'incomplete';
    this.$store.dispatch('translationModule/fetchTranslations', params);
  }

  protected onSearchDebounced() {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = window.setTimeout(() => {
      this.loadData();
    }, 400);
  }

  protected onEdit(entry: ITranslationEntry) {
    this.editingKey = entry.group + '.' + entry.item;
    this.editForm = { ...entry.translations };
  }

  protected onSave(entry: ITranslationEntry) {
    this.saving = true;
    this.$store.dispatch('translationModule/saveTranslation', {
      group: entry.group,
      item: entry.item,
      translations: this.editForm,
    });
  }

  protected onCreate() {
    this.loading = true;
    this.$store.dispatch('translationModule/createTranslation', {
      group: this.createForm.group,
      item: this.createForm.item,
      translations: this.createForm.translations,
    });
  }

  private onLoadedOK() {
    this.loading = false;
    this.showCreateDialog = false;
    this.createForm = { group: '', item: '', translations: {} };
  }

  private onLoadedKO() {
    this.loading = false;
  }

  private onMetaLoaded() {
    // Initialize createForm translations with empty strings for each language
    const translations: { [locale: string]: string } = {};
    for (const lang of this.languages) {
      translations[lang.code] = '';
    }
    this.createForm.translations = translations;
  }

  private onSaveOK() {
    this.saving = false;
    this.editingKey = '';
  }

  private onSaveKO() {
    this.saving = false;
  }
}

